"use strict";
// Module Federation requires an async boundary before importing shared modules.
// This dynamic import lets webpack negotiate shared singletons (React, etc.)
// before any code that uses them executes.
import("./bootstrap");
